import { BaseEntity, Validator } from '@core/services/orm/orm';
import { entityClasses } from '@archipad-js/archipad-model';

const validators = require.context('@archipad-models/models/validators/', false, /.ts$/);

export function getEntityClasses(): ReadonlyMap<string, typeof BaseEntity> {
    return new Map<string, typeof BaseEntity>(Object.entries(entityClasses));
}

export function getValidators(): ReadonlyArray<Validator> {
    const ret = [];
    for(const key of validators.keys()) {
        const module = validators(key);
        ret.push(module.default);
    }
    return ret;
}
